import { useWavesurfer } from '@wavesurfer/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { PlayIcon, PauseIcon } from 'pages/CreateVehicle/icons/AudioIcons';

type Props = {
  url: string;
};

const Container = styled.div`
  height: 44px;
  width: 100%;
  align-items: center;
  display: flex;
  border-radius: 8px;
  gap: 8px;
  padding: 0px 8px;
  background: transparent;
`;

const PlayPauseIcon = styled.div<{ removeHovered?: boolean }>`
  border-radius: 100%;
  width: 32px;
  height: 32px;
  background: ${props => (props.removeHovered ? 'rgba(226, 110, 116, 1)' : '#666666')};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TimeContainer = styled.div`
  border-radius: 8px;
  background: rgba(204, 204, 204, 0.8);
  color: rgba(102, 102, 102, 1);
  font-weight: 700;
  font-size: 10px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 24px;
`;

const formatTime = (seconds: number) => [seconds / 60, seconds % 60].map(v => `0${Math.floor(v)}`.slice(-2)).join(':');

export const AudioPlayer = ({ url }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { wavesurfer, isPlaying, currentTime, ...rest } = useWavesurfer({
    container: containerRef,
    height: 34,
    fillParent: true,
    barWidth: 1,
    barHeight: 1,
    barGap: 2,
    waveColor: 'rgba(204, 204, 204, 1)',
    progressColor: 'rgba(71, 151, 71, 1)',
    cursorWidth: 0,
    url,
    backend: 'WebAudio'
  });

  const onPlayPause = useCallback(async () => {
    if (!wavesurfer) return;
    wavesurfer.playPause();
  }, [wavesurfer]);

  const duration = wavesurfer?.getDuration() || 0;

  return (
    <Container>
      <PlayPauseIcon onClick={onPlayPause}>{isPlaying ? <PauseIcon /> : <PlayIcon />}</PlayPauseIcon>
      <div style={{ flexGrow: 1 }} ref={containerRef} />
      <TimeContainer>{formatTime(isPlaying ? currentTime : duration)}</TimeContainer>
    </Container>
  );
};
